import {MFA_STORE_NAME} from '../reducers/reducers'

export function getMfaCode(state) {
    const stored = state[MFA_STORE_NAME] || { }
    return stored.mfaCode
}
